import * as React from "react";
import Loadable from "react-loadable";

// components
import { Null } from "@clockwise/web-commons/src/components/null";
import { CircularProgress } from "@clockwise/web-commons/src/components/circular-progress";

// types
import { IContainer, IRendererProps } from "./WebAppOnboarding.d";

// TODO: Replace with React.Lazy
//////////////
// Loadable //
//////////////
export const WebAppOnboarding = Loadable({
  loader: () =>
    import(/* webpackChunkName: "web-app-onboarding" */ "./WebAppOnboarding").then(
      ({ WebAppOnboarding: c }) => c,
    ),
  loading: Null,
}) as React.ComponentClass<IContainer>;

export const WebAppOnboardingRenderer = Loadable({
  loader: () =>
    import(/* webpackChunkName: "web-app-onboarding-renderer" */ "./WebAppOnboardingRenderer").then(
      ({ WebAppOnboardingRenderer: c }) => c,
    ),
  loading: CircularProgress,
}) as React.ComponentClass<IRendererProps>;
